import React from 'react'
import {
  change as changeFieldValue, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import {cadastrarReserva} from '../../actions/reserva/actionsReserva'
import selecionarPassageiro from '../../actions/passageiro/selecionarPassageiro';
import {alterarPassageiroIda} from '../../actions/passageiro/alterarPassageiroIda';
import {alterarPassageiroVolta} from '../../actions/passageiro/alterarPassageiroVolta';
import Passageiro from './Passageiro';

export class ModalIncluirPassageiro extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.fechar = this.fechar.bind(this);
  }

  fechar () {
    this.props.changeFieldValue('formIncluirPassageiro', 'criancaColo', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'nomeCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'cpfCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimentoCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'documentoCrianca', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'cpfPassageiro', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'nomePassageiro', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'dtNascimento', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'documentoPassegeiro', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'tipoDocumento', '');

    this.props.changeFieldValue('formIncluirPassageiro', 'tipoEmissao', { label: 'Normal', value: 'NORMAL' });
    this.props.changeFieldValue('formIncluirPassageiro', 'nis', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'validade', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'renda', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'cargoProfissao', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'numeroDeficiente', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'telefone', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'matricula', '');
    this.props.changeFieldValue('formIncluirPassageiro', 'comAcompanhante', false);
    this.props.changeFieldValue('formIncluirPassageiro', 'ddi', {label: 'Brasil +55', value: 32});
    this.props.selecionarPassageiro(null)
  }

  fecharModal () {
    this.fechar()
    $('#modalIncluirPassageiro')
      .modal('hide');
    $('#modalIncluirPassageiro')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    let crianca
    if (values.criancaColo) {
      crianca = {
        nome: values.nomeCrianca,
        cpfCrianca: values.cpfCrianca,
        dtNascimentoCrianca: values.dtNascimentoCrianca,
        documentoCriacaComFoto: values.documentoCrianca
      }
    }

    this.props.changeFieldValue('formIncluirPassageiro', `vendaSeguro-${this.props.passagueiroSelecionado.poltronaId}`, this.ehGratuidadeTotal(values.tipoEmissao.value) ? false : values.vendaSeguro);

    const comAcompanhante = !this.props.ehIdoso100(values.tipoEmissao)
    && !this.props.ehDeficiente(values.tipoEmissao)? false: values.comAcompanhante
    
    const passageiro = {
      poltronaId: this.props.passagueiroSelecionado.poltronaId,
      numeroPoltrona: this.props.passagueiroSelecionado.numeroPoltrona,
      nome: values.nomePassageiro,
      documentoComFoto: values.documentoPassegeiro,
      dtNascimento: values.dtNascimento,
      cpfPassageiro: values.naoHabilitadoCpfPassageiro ? null : values.cpfPassageiro,
      valor: values.valorTotalPassageiro,
      criancaColo: values.criancaColo,
      criancaDto: crianca,
      sentido: this.props.passagueiroSelecionado.sentido,
      tipoEmissao: values.tipoEmissao.value,
      nis: values.nis,
      tipoDocumento: values.tipoDocumento.value,
      validade: values.validade,
      renda: values.renda ? values.renda.replace('R$', '') : '0,00',
      cargoProfissao: values.cargoProfissao,
      numeroDeficiente: values.numeroDeficiente,
      opcaoDescontoMeia: values.opcaoDescontoMeia,
      ddi: values.ddi.value ? Number(values.ddi.value) : 32,
      telefone: values.telefone,
      matricula: values.matricula,
      comAcompanhante,
      vendaSeguro: this.ehGratuidadeTotal(values.tipoEmissao.value) ? false : values.vendaSeguro
    }
    if (this.props.passagueiroSelecionado.sentido === 'IDA') {
      passageiro.taxaEmbarque = this.props.viagemIda.taxaEmbarque ? this.props.viagemIda.taxaEmbarque : '00.0'
      this.props.alterarPassageiroIda(passageiro)
    } else {
      passageiro.taxaEmbarque = this.props.viagemVolta ? this.props.viagemVolta.taxaEmbarque : '00.0'
      this.props.alterarPassageiroVolta(passageiro)
    }
    this.fecharModal()
  }

  ehGratuidadeTotal(tipoEmissao) {
      return tipoEmissao === 'ID_JOVEM_100'
          || tipoEmissao === 'IDOSO_100'
          || tipoEmissao === 'DEFICIENTE'
          || tipoEmissao === 'P_LIVRE_POLICIAL_AUDITOR'
          || tipoEmissao === 'CORTESIA'

  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalIncluirPassageiro' role='dialog'
           aria-labelledby='modalIncluirPassageiro' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">airline_seat_recline_normal</i>
                <span className="vx-modal-title">
                  {this.props.idReserva ? 'Editar Reserva' : 'Nova Reserva'}
                </span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                      onClick={this.fechar}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">
                <Passageiro preencherValoresParaEdicao={this.props.preencherValoresParaEdicao}
                            validarPreenchimentoCpfPassageiro={this.props.validarPreenchimentoCpfPassageiro}
                            ehMeiaPassagem={this.props.ehMeiaPassagem}
                            ehGratuidadeTotal={this.props.ehGratuidadeTotal}
                            vendaSeguroHabilitadaNaEmpresa={this.props.vendaSeguroHabilitadaNaEmpresa}
                            passagueiroSelecionado={this.props.passagueiroSelecionado}/>
              </div>
              <div className="vx-modal-footer">
                <button type="button" className="vx-btn-modal-cancel" data-dismiss="modal"
                        onClick={this.fechar}>Cancelar</button>
                {this.props.ehRemarcacao ?
                  <button type="submit" disabled={invalid || submitting}
                        className="vx-btn-modal-save">
                    <i className="material-icons">check</i>Salvar
                  </button> :
                  <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-btn-modal-save">
                    <i className="material-icons">check</i>Salvar
                  </button>}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    passageiros: state.passageiros,
    itinerarioSelecionado: state.itinerarioSelecionado,
    poltronasSelecionadas: state.poltronasSelecionadas,
    empresaSelecionada: state.empresaSelecionada,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    ehRemarcacao: state.remarcacao.reservasSelecionadas !== null,
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarReserva,
    selecionarPassageiro,
    alterarPassageiroIda,
    alterarPassageiroVolta

  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formIncluirPassageiro',
})(ModalIncluirPassageiro));
